<template>
  <div class="services-page">
    <h1 v-reveal class="page-title reveal">SERVICES</h1>

    <section
      v-for="group in groups"
      :id="group.id"
      :key="group.id"
      class="service-group"
    >
      <h2 v-reveal class="group-title reveal">{{ group.title }}</h2>

      <div class="cards">
        <article
          v-for="(card, index) in group.cards"
          :key="card.name"
          v-reveal
          class="card reveal"
          :style="{ '--reveal-delay': `${index * 0.1}s` }"
        >
          <header class="card-header">
            <p class="card-duration">{{ card.duration }}</p>
            <h3 class="card-name">{{ card.name }}</h3>
          </header>

          <p class="card-price">{{ card.price }}</p>

          <dl class="card-details">
            <div>
              <dt>Included</dt>
              <dd>
                <ul>
                  <li v-for="item in card.included" :key="item">{{ item }}</li>
                </ul>
              </dd>
            </div>
            <div v-if="card.addOns">
              <dt>Add-ons</dt>
              <dd>
                <ul>
                  <li v-for="item in card.addOns" :key="item">{{ item }}</li>
                </ul>
              </dd>
            </div>
          </dl>

          <a class="btn btn--solid card-book" :href="card.link" target="_blank" rel="noopener">
            Book now
          </a>
        </article>
      </div>

    </section>
  </div>
</template>

<script>
const PRINT_ADD_ONS = [
  "£30 per additional edited print",
  "Film work (client covers roll + development)",
];

const SELF_TAPE_INCLUDED = ["Reader", "Light direction or coaching (optional)", "Basic editing"];

const SELF_TAPE_ADD_ONS = ["£15 per extra 30 mins"];

export default {
  name: "BookingPage",
  data() {
    return {
      groups: [
        {
          id: "self-tapes",
          title: "SELF-TAPES",
          cards: [
            {
              name: "Self-tape session",
              duration: "60 minutes",
              price: "£35",
              included: SELF_TAPE_INCLUDED,
              addOns: SELF_TAPE_ADD_ONS,
              link: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ20A8MPX36fExZH9AoPjqndDcFR2nQi0J1c9cOx9z6-uoBw_TYb9hYVL64100dbUTjlgU6Y6mvl",
            },
            {
              name: "Self-tape session",
              duration: "90 minutes",
              price: "£50",
              included: SELF_TAPE_INCLUDED,
              addOns: SELF_TAPE_ADD_ONS,
              link: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0idaXeGnkaesJWje0LkEjuXxINHk92zAgW2BTHbz0yP9yon1ipf1_pesJVmK50OV_Ru827vmv5",
            },
            {
              name: "Self-tape session",
              duration: "120 minutes",
              price: "£65",
              included: SELF_TAPE_INCLUDED,
              addOns: SELF_TAPE_ADD_ONS,
              link: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0AWLldxJfYQlpvoIMoUdMGukj0slRexOphvo8l4o_VGuwIvyyNFISXJ4_pI-vRSLTUAy8qc19L",
            },
          ],
        },
        {
          id: "headshots",
          title: "HEADSHOTS",
          cards: [
            {
              name: "The Actor Pack",
              duration: "120 minutes",
              price: "£250",
              included: ["Headshot/portrait style shots", "4 prints"],
              addOns: PRINT_ADD_ONS,
              link: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3aAiyfuOsNxPrIufmC2gmgp2nqElt_hNXamnskkAi-um8Izdx1uEeNyDlfiLls99IIC-PeH-M_",
            },
            {
              name: "The Poet Pack",
              duration: "120 minutes",
              price: "£350",
              included: [
                "Film + digital headshot/portrait shots",
                "35mm or medium format, B&W or color (mix & match)",
                "4 prints",
              ],
              addOns: PRINT_ADD_ONS,
              link: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1GRL_KeBb9jnh2IwIXzgBwJ4DP2l1ygZLanTWjF1YuvmgVnQStZvAqAGr-fhY5cAvO_hYnCPXf",
            },
            {
              name: "The Works Pack",
              duration: "180 minutes",
              price: "£500",
              included: ["Headshot, portrait, editorial style shots", "3-hour session + 7 prints"],
              addOns: PRINT_ADD_ONS,
              link: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1GRL_KeBb9jnh2IwIXzgBwJ4DP2l1ygZLanTWjF1YuvmgVnQStZvAqAGr-fhY5cAvO_hYnCPXf",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.services-page {
  max-width: 1240px;
  margin: 0 auto;
  padding: 56px 40px 140px;
  display: flex;
  flex-direction: column;
  gap: 96px;
  color: var(--color-ink);
}

.page-title {
  font-family: "brown-sugar";
  font-size: 50px;
  line-height: 1;
  margin-bottom: -48px;
}

.service-group {
  display: flex;
  flex-direction: column;
  gap: 28px;
  scroll-margin-top: calc(var(--nav-height) + 24px);
}

.group-title {
  font-family: "brown-sugar";
  font-size: clamp(30px, 3vw, 38px);
  line-height: 1.1;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-ink);
}

/* Cards sit side by side and wrap to new rows when space runs out */
.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  flex: 1 1 260px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 28px;
  border: 1px solid var(--color-ink);
  background-color: var(--color-paper);
  /* Keeps the shared reveal's stagger delay on the fade-in, but not on the hover */
  transition: background-color 0.35s ease,
    opacity 0.9s ease var(--reveal-delay, 0s),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--reveal-delay, 0s);
}

.card:hover,
.card:focus-within {
  background-color: var(--color-butter);
}

.card-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.card-duration {
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.card-name {
  font-family: "brown-sugar";
  font-size: 24px;
  line-height: 1.15;
}

.card-price {
  font-size: 40px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 14px;
  line-height: 1.6;
  padding-top: 20px;
  border-top: 1px solid var(--color-ink);
}

.card-details dt {
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.card-details li {
  position: relative;
  padding-left: 16px;
}

.card-details li::before {
  content: "–";
  position: absolute;
  left: 0;
}

/* Push the button to the bottom so buttons line up across a row */
.card-book {
  margin-top: auto;
  text-align: center;
}

@media (max-width: 899px) {
  .services-page {
    padding: 40px 20px 96px;
    gap: 72px;
  }

  .page-title {
    font-size: 40px;
    margin-bottom: -40px;
  }
}
</style>
